import { styled } from 'styled-components';
import DropdownArrow from 'app/visuals/images/icons/dropdown-arrow.svg?react';

export const SortIcon = styled(DropdownArrow)<{ $isDescending: boolean }>`
  position: relative;
  top: ${({ theme: { spacing } }) => `${spacing(1)}px`};
  color: ${({ theme: { colors } }) => colors.mono.text01};
  transform: ${({ $isDescending }) => `rotate(${$isDescending ? 180 : 0}deg)`};
`;
